import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LandingPage.css";
import { API_ENDPOINTS } from "../../config/api";
import AuthModal from "../arnold/AuthModal";

function LandingPage() {
    const navigate = useNavigate();
    // Estado para controlar si la imagen está volteada
    const [isFlipped, setIsFlipped] = useState(false);
    // Estado para almacenar los datos del perfil
    const [profileData, setProfileData] = useState(null);
    // Estado para controlar la carga
    const [loading, setLoading] = useState(true);
    // Estado para manejar errores
    const [error, setError] = useState(null);
    // Estados para Arnold
    const [showAuthModal, setShowAuthModal] = useState(false);
    // Estados para long press en móvil
    const [longPressTimer, setLongPressTimer] = useState(null);

    // Efecto para obtener los datos del perfil al cargar la página
    useEffect(() => {
        axios.get(API_ENDPOINTS.PROFILE_DATA())
            .then((response) => {
                setProfileData(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error al obtener los datos del perfil:", error);
                setError(error);
                setLoading(false);
            });
    }, []);

    // Limpiar timer al desmontar el componente
    useEffect(() => {
        return () => {
            if (longPressTimer) {
                clearTimeout(longPressTimer);
            }
        };
    }, [longPressTimer]);


    // Función para manejar el clic en la imagen
    const handleImageClick = () => {
        // Si los datos del perfil no están cargados, no hacer nada
        if (!profileData) return;

        const newIsFlipped = !isFlipped;
        setIsFlipped(newIsFlipped);

        // Determinamos el tipo de imagen en función de si está volteado
        const imageType = newIsFlipped ? "secondary" : "main";

        // Registramos la vista para el tipo de imagen correspondiente
        registerView(imageType);
    };

    // Función para manejar el easter egg (doble clic + Shift en desktop, triple tap en móvil)
    const handleImageDoubleClick = (e) => {
        if (e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            setShowAuthModal(true);
        }
    };

    // Función para manejar el easter egg en móvil (long press)
    const handleTouchStart = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Iniciar timer para long press (800ms)
        const timer = setTimeout(() => {
            setShowAuthModal(true);
        }, 800);
        
        setLongPressTimer(timer);
    };

    const handleTouchEnd = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Cancelar long press si se suelta antes del tiempo
        if (longPressTimer) {
            clearTimeout(longPressTimer);
            setLongPressTimer(null);
        }
    };

    const handleTouchMove = (e) => {
        // Cancelar long press si se mueve el dedo
        if (longPressTimer) {
            clearTimeout(longPressTimer);
            setLongPressTimer(null);
        }
    };

    // Función para manejar la autenticación exitosa
    const handleAuthSuccess = () => {
        navigate('/arnold/');
    };

    // Función para registrar la vista de una imagen
    const registerView = (imageType) => {
        axios.post(API_ENDPOINTS.PROFILE_IMAGE_VIEW(imageType))
            .then((response) => {
                console.log(`Se ha registrado una vista para la imagen con tipo ${imageType}`);
            })
            .catch((error) => {
                console.error(`Error al registrar la vista para la imagen con tipo ${imageType}:`, error);
            });
    };

    // Mostrar indicador de carga si los datos aún no están disponibles
    if (loading) {
        return <div>Cargando...</div>;
    }

    // Mostrar mensaje de error si ocurrió un error al cargar los datos
    if (error) {
        return <div>Error al cargar los datos del perfil: {error.message}</div>;
    }

    return (
        <div className="landing-page">
            <div className="landing-page-header">
                <div 
                    className="flip-container" 
                    onClick={handleImageClick} 
                    onDoubleClick={handleImageDoubleClick}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                    onTouchMove={handleTouchMove}
                >
                    <div className={`flipper ${isFlipped ? 'flipped' : ''}`}>
                        <div className="front">
                            <img src={profileData.main_photo.url} alt="Foto de Sebastian Tobar Quintero" />
                        </div>
                        <div className="back">
                            <img src={profileData.secondary_photo.url} alt="Foto secundaria de Sebastian Tobar Quintero" />
                        </div>
                    </div>
                </div>
                <h1>{profileData.title}</h1>
                <p>
                    {profileData.description}
                </p>
            </div>
            <div className="landing-page-footer">
                <div className="social-links">
                    <a
                        href="https://co.linkedin.com/in/sebastq/es/?utm_source=sebastians_blog&utm_medium=linkedin&utm_campaign=sebastians_blog_lading_page"
                        target="_blank"
                        rel="noreferrer"
                    >
                        LinkedIn
                    </a>
                    <a
                        href="https://github.com/sebastiantq-protonmail/?utm_source=sebastians_blog&utm_medium=github&utm_campaign=sebastians_blog_lading_page"
                        target="_blank"
                        rel="noreferrer"
                    >
                        GitHub
                    </a>
                    <a
                        href="https://www.instagram.com/sebastq_/?utm_source=sebastians_blog&utm_medium=instagram&utm_campaign=sebastians_blog_lading_page"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Instagram
                    </a>
                    <a
                        href="https://x.com/sebastq_/?utm_source=sebastians_blog&utm_medium=twitter&utm_campaign=sebastians_blog_lading_page"
                        target="_blank"
                        rel="noreferrer"
                    >
                        X
                    </a>
                </div>
                <p>© 202X Sebastian. Todos los derechos reservados.</p>
                <p>¿Esto sirve de algo? 😂</p>
            </div>
            
            {/* Modal de Arnold */}
            <AuthModal 
                isOpen={showAuthModal}
                onClose={() => setShowAuthModal(false)}
                onAuthSuccess={handleAuthSuccess}
            />
        </div>
    );
}

export default LandingPage;
